import React, { FunctionComponent } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { Dropdown } from 'semantic-ui-react';
import withStyles from 'react-jss';

import { signOut, useUserMgmt } from 'components/UserMgmt/UserMgmt.context';
import { REVOKE_TOKEN } from 'components/UserMgmt/UserMgmt.queries';
import styles from 'components/Header/components/SecondaryNav/SecondaryNav.styles';

import { ClassProp } from 'helpers/types';

type Styles = ClassProp<typeof styles>;

type Props = {
  classes: Styles;
};

const ShowLogout: FunctionComponent<Props> = ({ classes }) => {
  const { checkStorage } = useUserMgmt();
  const [revokeToken] = useMutation(REVOKE_TOKEN, {
    onError: (e) => {
      console.error(e.message);
    },
  });
  const handleLogout = async () => {
    const { refreshToken } = checkStorage();
    await Promise.all([
      revokeToken({
        variables: {
          token: refreshToken,
          clientId: process.env.COGNITO_USER_POOL_WEB_CLIENT_ID,
        },
      }),
      signOut(),
    ]);
  };

  return (
    <Dropdown.Item className={classes.logoutBtn} onClick={handleLogout}>
      Logout
    </Dropdown.Item>
  );
};

export default withStyles(styles)(ShowLogout);
